import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class PAComponiFatturaSummaryController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        'ArchiSmallServices',
        '$uibModal'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
        /* tslint:disable:no-string-literal */
        $scope.pageHeader = 'Componi Fattura';
        $scope.pageSubHeader = 'Riepilogo';

        let result = store.get('fatturazionepaComponiFattura-Result');
        if (result === undefined) {
            $state.go('home.home-index');
        }
        $scope.result = result;
        $scope.next = () => {
            store.remove('fatturazionepaComponiFattura-Result');
            store.remove('fatturazionepaComponiFattura');
            $state.go('home.fatturazione-pa');
        };
    }

}

export const PAComponiFatturaSummaryComponent: ng.IComponentOptions = {
    template: require('./pa-componi-fattura-summary.html'),
    controller: PAComponiFatturaSummaryController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-componi-fattura-summary/pa-componi-fattura-summary.ts